import React from "react";

const PaymentItem = ({ item, onClick }) => {
  const getPaymentOptionSubtitle = (item) => {
    switch (item.key) {
      case "card":
        return "All cards supported";
      case "upi":
        return "BHIM, Google, Paytm";
      case "netbanking":
        return "All Banks supported";
      case "paytm":
        return "Enter registered mobile number";
      default:
        return "";
    }
  };

  return (
    <div
      onClick={onClick}
      className="p-4 h-[61px] border-b-[1px] border-[#E5E5E5] flex justify-between items-center bg-white last:border-b-0"
    >
      <div>
        <p className="font-custom font-semibold text-base capitalize">
          {item.value}
        </p>

        {getPaymentOptionSubtitle(item) !== "" && (
          <p className="font-custom font-mediun text-xs text-gray mt-1">
            {getPaymentOptionSubtitle(item)}
          </p>
        )}
      </div>
      <div className="w-[84px] h-[21px] rounded-[20px] flex items-center justify-center border-[1.24px] border-primary">
        <p className="font-custom font-semibold text-xs text-primary">Select</p>
      </div>
    </div>
  );
};

export default PaymentItem;
